var _ellipse, _g, _path, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1016,
    height: 313,
    viewBox: "470 65 1016 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 978,
    cy: 265,
    rx: 488,
    ry: 103,
    fill: "#EFE7D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1589_72)",
    transform: "translate(20, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M774.859 200V173.047H797.516V101.016H783.531L780.406 127.344H754.625V75.625H881.031V127.344H855.25L852.125 101.016H838.141V173.047H860.797V200H774.859ZM889.625 200V173.047H902.125V102.578H889.625V75.625H952.359V102.578H941.812V124.453H974.625V102.578H964.078V75.625H1026.81V102.578H1014.31V173.047H1026.81V200H964.078V173.047H974.625V150.078H941.812V173.047H952.359V200H889.625ZM1036.81 200V173.047H1049.31V102.578H1036.81V75.625H1147.44V125.078H1121.66L1118.92 102.188H1089V123.281H1110.09V149.844H1089V173.438H1118.92L1121.66 147.109H1147.44V200H1036.81Z",
    fill: "#AD5D4E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M705.374 116.137L714.808 106.254H718.514V127.143L726.263 124.11L739.852 123.661L742.435 126.02L726.038 139.047L742.435 152.187L739.627 154.994L726.487 154.32L718.514 151.063V160.497L709.305 170.38H705.374V151.288L697.513 154.545L684.261 155.219L681.453 152.411L697.962 139.047L681.678 126.02L684.036 123.437L697.737 123.886L705.374 127.143V116.137Z",
    fill: "#F2C94C",
    transform: "translate(20, 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.37 116.137L1206.81 106.254H1210.51V127.143L1218.26 124.11L1231.85 123.661L1234.43 126.02L1218.04 139.047L1234.43 152.187L1231.63 154.994L1218.49 154.32L1210.51 151.063V160.497L1201.3 170.38H1197.37V151.288L1189.51 154.545L1176.26 155.219L1173.45 152.411L1189.96 139.047L1173.68 126.02L1176.04 123.437L1189.74 123.886L1197.37 127.143V116.137Z",
    fill: "#F2C94C",
    transform: "translate(20, 0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1589_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.241 330.104C562.182 328.384 549.478 324.182 539.128 317.495C528.83 310.815 521.276 302.142 516.465 291.475C511.655 280.808 510.029 268.644 511.589 254.983C512.99 242.719 516.593 232.279 522.4 223.664C528.264 215.002 535.784 208.6 544.959 204.458C554.185 200.322 564.543 198.91 576.03 200.222C584.672 201.208 591.83 203.258 597.503 206.369C603.228 209.487 607.707 213.642 610.941 218.834L616.291 207.099L637.637 209.537L632.505 254.479L603.786 251.2C603.594 244.153 602.046 238.891 599.14 235.414C596.241 231.886 591.764 229.776 585.709 229.084C580.897 228.535 576.359 229.248 572.097 231.226C567.841 233.151 564.236 236.488 561.282 241.235C558.335 245.931 556.418 252.16 555.531 259.922C554.214 271.462 555.949 280.598 560.737 287.33C565.577 294.069 573.094 298.02 583.288 299.184C587.531 299.668 591.345 299.553 594.729 298.839L596.165 286.264L581.417 284.58L584.076 261.294L633.753 266.967L627.159 324.716C622.984 326.389 618.111 327.746 612.54 328.787C606.969 329.829 601.155 330.475 595.098 330.727C589.041 330.979 583.088 330.771 577.241 330.104Z",
    fill: "#AD5D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.824 332.103L641.954 305.234L653.247 306.129L682.102 237.727L665.358 236.4L667.488 209.531L744.434 215.631L765.862 315.057L777.155 315.953L775.025 342.822L705.166 337.283L707.296 310.414L720.146 311.433L717.644 297.52L685.558 294.976L680.427 308.284L693.278 309.303L691.147 336.172L639.824 332.103ZM692.864 275.963L714.048 277.642L707.158 239.008L692.864 275.963Z",
    fill: "#AD5D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.649 340.418L782.849 313.492L795.336 314.048L798.474 243.649L785.986 243.093L787.186 216.166L857.429 219.297L856.229 246.223L839.059 245.458L835.904 316.247L861.347 317.381L865.767 288.408L891.522 289.556L889.042 345.204L781.649 340.418Z",
    fill: "#AD5D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.016 343.537L900.428 316.587L912.926 316.778L914.004 246.317L901.505 246.126L901.917 219.176L972.222 220.251L971.809 247.201L954.624 246.938L953.541 317.79L979.006 318.179L982.577 289.089L1008.35 289.484L1007.5 345.18L900.016 343.537Z",
    fill: "#AD5D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.39 343.193L1018.01 316.243L1030.51 316.068L1029.53 245.606L1017.03 245.781L1016.66 218.83L1127.27 217.286L1127.96 266.735L1102.18 267.095L1099.13 244.244L1069.21 244.662L1069.5 265.754L1090.59 265.459L1090.97 292.019L1069.87 292.314L1070.2 315.905L1100.12 315.487L1102.49 289.124L1128.27 288.764L1129.01 341.649L1018.39 343.193Z",
    fill: "#AD5D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.38 339.317L1137.21 312.389L1149.7 311.849L1146.66 241.446L1134.17 241.986L1133 215.058L1204.73 211.957C1220.24 211.287 1232.28 213.686 1240.86 219.154C1249.44 224.57 1253.96 232.871 1254.45 244.059C1254.76 251.292 1253.23 257.379 1249.84 262.322C1246.46 267.264 1241.74 270.883 1235.69 273.178C1240.65 274.579 1244.37 276.947 1246.86 280.28C1249.41 283.61 1250.84 287.745 1251.15 292.684L1251.59 299.156C1251.81 301.909 1252.5 303.964 1253.66 305.322C1254.86 306.626 1256.81 307.219 1259.52 307.102L1267.79 306.744L1268.96 333.672L1241.8 334.846C1231.86 335.276 1224.39 333.305 1219.41 328.933C1214.47 324.506 1211.76 317.846 1211.27 308.953L1210.67 298.579C1210.15 290.26 1206.12 286.264 1198.58 286.59L1188.35 287.032L1189.35 310.135L1199.89 309.68L1201.05 336.608L1138.38 339.317ZM1198.37 238.429L1186.27 238.952L1187.41 265.333L1199.51 264.81C1209.5 264.378 1214.31 259.766 1213.93 250.972C1213.55 242.178 1208.36 237.997 1198.37 238.429Z",
    fill: "#AD5D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.3 329.662L1285.28 302.785L1307.87 301.084L1305.76 273.039L1266.42 233.458L1255.13 234.308L1253.1 207.431L1323.53 202.129L1325.55 229.006L1316.98 229.651L1333.64 246.965L1345.34 227.517L1336.77 228.162L1334.75 201.285L1384.14 197.566L1386.16 224.443L1374.87 225.294L1345.46 271.695L1347.44 298.105L1370.04 296.404L1372.06 323.281L1287.3 329.662Z",
    fill: "#AD5D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.08 274.703L1393.77 225.427L1390.35 194.365L1437.56 189.164L1440.98 220.226L1437.73 271.28L1408.08 274.703ZM1427.81 317.488C1421.23 318.213 1415.75 317.008 1411.37 313.875C1406.99 310.742 1404.47 306.147 1403.8 300.09C1403.14 294.085 1404.61 289.128 1408.22 285.22C1411.82 281.313 1416.91 278.997 1423.49 278.272C1430.11 277.542 1435.58 278.695 1439.9 281.73C1444.27 284.76 1446.78 289.277 1447.45 295.282C1448.11 301.339 1446.65 306.374 1443.06 310.385C1439.46 314.396 1434.38 316.764 1427.81 317.488Z",
    fill: "#AD5D4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1589_72",
    x: 754.625,
    y: 75.625,
    width: 397.812,
    height: 129.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.788235 0 0 0 0 0.298039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1589_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1589_72",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1589_72",
    x: 503.967,
    y: 189.164,
    width: 952.446,
    height: 161.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.788235 0 0 0 0 0.298039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1589_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1589_72",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryHero);
export default __webpack_public_path__ + "static/media/GalleryHero.2494660663358acc34f6e199ca468d53.svg";
export { ForwardRef as ReactComponent };